var map = {
	"./AD.png": 5856,
	"./AL.png": 7336,
	"./AM.png": 7553,
	"./AT.png": 5440,
	"./AZ.png": 2302,
	"./BA.png": 6272,
	"./BE.png": 6036,
	"./BG.png": 3398,
	"./BY.png": 3048,
	"./CH.png": 246,
	"./CY.png": 6079,
	"./CZ.png": 3620,
	"./DE.png": 2126,
	"./DK.png": 7792,
	"./EE.png": 4325,
	"./ES.png": 2051,
	"./FI.png": 3116,
	"./FR.png": 2927,
	"./GB.png": 8192,
	"./GE.png": 3567,
	"./GR.png": 8608,
	"./HR.png": 469,
	"./HU.png": 42,
	"./IE.png": 9889,
	"./IS.png": 2999,
	"./IT.png": 3384,
	"./KZ.png": 9932,
	"./LI.png": 3834,
	"./LT.png": 5404,
	"./LU.png": 6694,
	"./LV.png": 8317,
	"./MC.png": 7611,
	"./MD.png": 5956,
	"./ME.png": 5901,
	"./MK.png": 3619,
	"./MT.png": 4356,
	"./NL.png": 4777,
	"./NO.png": 8194,
	"./PL.png": 5699,
	"./PT.png": 2347,
	"./RO.png": 1662,
	"./RS.png": 8626,
	"./RU.png": 9844,
	"./SE.png": 3027,
	"./SI.png": 6015,
	"./SK.png": 618,
	"./SM.png": 3019,
	"./TR.png": 737,
	"./UA.png": 561,
	"./VA.png": 9460,
	"./XK.png": 2596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7900;